var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204 72.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea75ad;}.cls-2{fill:#5d3233;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.1,53.24s-36.07,22.07-73,14.11S41.38,26.1,41.38,26.1s41.06-32.81,78-24.86S178.1,53.24,178.1,53.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,44.45A151.62,151.62,0,0,1,51,23.18c2.3-.45,4.6-.85,6.91-1.27,1.15-.21,2.31-.4,3.47-.59l3.49-.4c2.34-.25,4.67-.58,7-.73l7-.35a164.83,164.83,0,0,1,28.16,1.63,168.42,168.42,0,0,1,53.25,17.39,163.9,163.9,0,0,1,23.5,14.94q5.53,4.2,10.62,8.92a94,94,0,0,1,9.5,10c-7.81-4.83-15.72-9.16-23.76-13.13S164.08,52,155.82,48.88a239.66,239.66,0,0,0-50.74-13.56l-6.48-.89c-2.16-.25-4.34-.38-6.51-.61s-4.35-.35-6.53-.46l-3.27-.17-1.63-.08-1.64,0A236,236,0,0,0,52.74,34c-2.18.29-4.38.51-6.58.77-1.09.13-2.2.24-3.29.39l-3.28.53c-2.2.34-4.39.71-6.6,1l-6.56,1.33-3.31.63c-1.11.19-2.18.53-3.28.77-2.19.52-4.37,1.06-6.59,1.55l-1.66.38L10,41.85l-3.28.9C4.45,43.31,2.25,43.93,0,44.45Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.6f102031.svg";
export { ForwardRef as ReactComponent };